import { render } from "./EvidenceMain.vue?vue&type=template&id=b42caf2e&ts=true"
import script from "./EvidenceMain.vue?vue&type=script&lang=ts"
export * from "./EvidenceMain.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__